/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthGeneratedDocumentSelection200ResponseData
 */
export interface UpdatePalReauthGeneratedDocumentSelection200ResponseData {
    /**
     * 
     */
    screener_generated_document_id: string;
    /**
     * 
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the UpdatePalReauthGeneratedDocumentSelection200ResponseData interface.
 */
export function instanceOfUpdatePalReauthGeneratedDocumentSelection200ResponseData(value: object): value is UpdatePalReauthGeneratedDocumentSelection200ResponseData {
    if (!('screener_generated_document_id' in value) || value['screener_generated_document_id'] === undefined) return false;
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSON(json: any): UpdatePalReauthGeneratedDocumentSelection200ResponseData {
    return UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSONTyped(json, false);
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthGeneratedDocumentSelection200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'screener_generated_document_id': json['screener_generated_document_id'],
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSON(json: any): UpdatePalReauthGeneratedDocumentSelection200ResponseData {
    return UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSONTyped(json, false);
}

export function UpdatePalReauthGeneratedDocumentSelection200ResponseDataToJSONTyped(value?: UpdatePalReauthGeneratedDocumentSelection200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screener_generated_document_id': value['screener_generated_document_id'],
        'is_selected': value['is_selected'],
    };
}

